import React from 'react';
import {
  Container,
  Typography,
  Box,
  AppBar,
  Toolbar,
  Button,
  Paper,
  IconButton,
} from '@mui/material';
import { QrCode2, ArrowBack, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PrivacyPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate('/');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc' }}>
      <AppBar position="static" color="primary" elevation={0} sx={{ bgcolor: '#1F425C' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="back"
            onClick={handleBack}
            sx={{ mr: 2, color: '#fff' }}
          >
            <ArrowBack />
          </IconButton>
                      <img src="/HINDALCO.NS_BIG.png" alt="Hindalco" style={{ marginRight: '16px', height: '32px', width: 'auto' }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: '#fff', fontWeight: 500 }}>
            Privacy Policy - Hindalco QR Management
          </Typography>
          <Button
            color="inherit"
            startIcon={<Home />}
            onClick={handleHome}
            sx={{
              ml: 2,
              color: '#fff',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Home
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ mt: 4, mb: 12, pb: 4 }}>
        <Paper elevation={2} sx={{
          p: { xs: 3, sm: 4, md: 6 },
          borderRadius: 3,
          bgcolor: '#fff',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
        }}>
          <Typography variant="h3" sx={{ 
            color: '#1F425C', 
            fontWeight: 600, 
            mb: 4,
            textAlign: 'center'
          }}>
            Privacy Policy
          </Typography>

          <Typography variant="h6" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
            Last Updated: [Date to be added]
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Information We Collect
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Information about what data is collected from users of the QR Management system]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              How We Use Your Information
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - How the collected data is used for QR code management and package tracking]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Data Security
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Security measures taken to protect user data and QR code information]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Cookies and Tracking
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Information about cookies, sessions, and tracking technologies used]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Third-Party Services
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Any third-party services integrated with the QR management system]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Your Rights
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - User rights regarding their data, access, modification, deletion]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Contact Information
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Contact details for privacy-related inquiries]
            </Typography>
          </Box>

          <Box sx={{ 
            mt: 6, 
            p: 3, 
            bgcolor: '#f8f9fa', 
            borderRadius: 2,
            border: '1px dashed #dee2e6'
          }}>
            <Typography variant="h6" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              📝 Admin Note
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              This is a template page. Please replace the placeholder content above with your actual privacy policy content. 
              Consider including specific details about your QR code management system, data handling practices, 
              and compliance with relevant privacy regulations.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPage;